import React from 'react';
import Select from 'react-select';
import WatchlistNotifications from './lis-watchlist-notifications';
import QuickAdd from '../../lis-public/components/lis-bill-search/quick-add-bills';
import { CustomOption, DuplicateWatchlistWarning } from '../../services/legislation-helper-service';
import DeleteWatchlistModal from '../../lis-public/components/lis-public-delete-watchlist-modal';

const MERGE = "MERGE";
const DELETE = "DELETE";
const COPY = "COPY";

class CollectionControls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopup: { DELETE: false, MERGE: false },
            selectedWatchlists: [],
            selectedMergeWatchlists: [],
            editWatchlistName: false,
            newName: '',
            newDescription: '',
            newNote: {
                Name: '',
                WatchListID: -1,
                isNew: true,
                value: '',
                Description: ''
            },
            menuIsOpen: false,
        };
        this.togglePopup = this.togglePopup.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.deleteCollection = this.deleteCollection.bind(this);
        this.handleWatchlistChange = this.handleWatchlistChange.bind(this);
        this.handleMergeWatchlistChange = this.handleMergeWatchlistChange.bind(this);
        this.handleToggleCompositeView = this.handleToggleCompositeView.bind(this);
        this.toggleEditWatchlistName = this.toggleEditWatchlistName.bind(this);
        this.saveWatchlistName = this.saveWatchlistName.bind(this);
        this.addToWatchlists = this.addToWatchlists.bind(this);
        this.copyWatchlist = this.copyWatchlist.bind(this);

        this.toggleMenuIsOpen = this.toggleMenuIsOpen.bind(this);
        this.handleIsRelated = this.handleIsRelated.bind(this);
        this.manuallyFocusTheNextOne = this.manuallyFocusTheNextOne.bind(this);
        this.selectRef = React.createRef();
    }

    togglePopup(type) {
        let showPopup = { ...this.state.showPopup };
        showPopup[type] = !showPopup[type];
        this.setState({
            showPopup,
            selectedMergeWatchlists: []
        });
    }

    handleTextChange(key, val) {
        this.setState({
            [key]: val
        })
    }

    deleteCollection() {
        let showPopup = { ...this.state.showPopup };
        showPopup[DELETE] = !showPopup[DELETE];
        this.setState({
            showPopup
        });
        this.props.deleteCollection();
    }

    handleWatchlistChange(val) {
        this.setState({
            selectedWatchlists: val,
            menuIsOpen: false
        });
    }

    handleMergeWatchlistChange(val) {
        this.setState({
            selectedMergeWatchlists: val,
            menuIsOpen: false
        });
    }

    handleToggleCompositeView() {
        this.props.handleToggleCompositeView()
    }

    toggleEditWatchlistName() {
        this.setState(state => ({
            editWatchlistName: !state.editWatchlistName,
            newName: this.props.selectedCollection.Name || '',
            newDescription: this.props.selectedCollection.Description || ''
        }));
    }

    saveWatchlistName() {
        let selectedCollection = { ...this.props.selectedCollection };
        selectedCollection.Name = this.state.newName;
        selectedCollection.Description = this.state.newDescription;
        this.props.handleCollectionChange(selectedCollection);
        this.setState({
            editWatchlistName: false
        });
    }

    /**
     *
     * @param {boolean | undefined} merge
     * true = merge, false = copy, undefined = add
    */
    addToWatchlists(merge) {
        let watchlists = merge ? JSON.parse(JSON.stringify(this.state.selectedMergeWatchlists)) : JSON.parse(JSON.stringify(this.state.selectedWatchlists));
        this.props.addToWatchlists(watchlists, merge, (saveResultCollections) => {
            let showPopup = { ...this.state.showPopup };
            if (!merge) {
                // they are adding bills to one or more watchlist(s) - we need to update the selectedWatchlists state values because their mod dates have now changed
                for (let i = 0; i < watchlists.length; i++) {
                    const associatedWatchlist = saveResultCollections.find(c => c.WatchListID === watchlists[i].WatchListID);
                    if (associatedWatchlist && associatedWatchlist.ModificationDate !== watchlists[i].ModificationDate) {
                        watchlists[i] = associatedWatchlist
                    };
                }
            } else {
                // they are merging - we need to close the popup, and we also set the selectedMergeWatchlists state value to empty array because --
                // there's no need to go through the above loop just to be able to keep the same watchlists selected considering they've already been merged and it's pointless to do it again
                showPopup[MERGE] = false;
                showPopup[COPY] = false;
            }
            this.setState({ selectedWatchlists: [], selectedMergeWatchlists: [], showPopup })
        }, merge === undefined ? 'add' : this.state.showPopup[MERGE] ? 'merge' : 'copy');
    }

    copyWatchlist(newName) {
        this.setState({
            selectedMergeWatchlists: [{
                __isNew__: true,
                label: newName,
                value: newName
            }]
        }, () => {
            this.addToWatchlists(true)
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedCollection?.WatchListID !== prevProps.selectedCollection?.WatchListID) {
            this.setState({
                editWatchlistName: false
            });
        }
    }

    toggleMenuIsOpen(value) {
        if (value === undefined) {
            this.setState({ menuIsOpen: !this.state.menuIsOpen });
        } else {
            this.setState({ menuIsOpen: value });
        }
    }

    handleIsRelated(e, direction) {
        const relatedTarget = e.relatedTarget
        if (relatedTarget === null) {
            this.toggleMenuIsOpen(false);
        }
        const isParOfTheSelect = (el) => {
            let parent = el?.parentElement;
            if (parent) {
                if (parent.id === 'sr-watchlist-name-control-bad') {
                    return true;
                } else {
                    return isParOfTheSelect(parent);
                }
            } else {
                return false;
            }
        }
        const shouldClose = isParOfTheSelect(relatedTarget);
        if (shouldClose) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (shouldClose && direction) {

        } else {
            this.toggleMenuIsOpen(shouldClose);
        }
    }

    manuallyFocusTheNextOne(direction) {
        // The id is different depending on where the Modal is ...
        const mainThing = document.getElementById('sr-watchlist-name-control-bad');
        mainThing?.getElementsByTagName('input')[0]?.focus();
        if (direction === 'down') {
            this.selectRef?.current?.select?.focusOption('down');
        } else if (direction === 'up') {
            this.selectRef?.current?.select?.focusOption('up');
        }
    }

    render() {
        const { selectedCollection, selectedCollectionIndex, calendarHeader, collections, searchMade, isPaid } = this.props;
        const { selectedWatchlists, selectedMergeWatchlists } = this.state;
        if (!selectedCollection && !calendarHeader && (this.props.isBillManagement || !searchMade)) {
            return null;
        }
        const buttonDisabled = !selectedWatchlists || !selectedWatchlists.length || this.props.checkedBills.every(c => !c || this.props.collectionIsSaving);
        const mergeButtonDisabled = !selectedMergeWatchlists || !selectedMergeWatchlists.length;
        const messages = this.props.messages?.length > 0 ?
            this.props.messages.map((message, i) =>
                <MessageBox text={message.text} show={message.show} type={message.type} key={message.text} closeMessage={() => this.props.closeMessage(i)} />)
            : <div className='message-box hide' />
        if (!selectedCollection && !calendarHeader) {
            return (
                <div className="dlas-forms collection-controls" style={{ marginBottom: "5px" }}>
                    <h4 style={{ margin: 0 }}>Add bills from search results to one or more watchlists</h4>
                    <div className="inner-grid two">
                        <div>
                            <label id='add-watchlist-label' htmlFor="sr-watchlist-name-control-bad">Watchlist Name</label>
                            <Select
                                ref={this.selectRef}
                                id="sr-watchlist-name-control-bad"
                                styles={selectStyle}
                                options={[{ isNew: true }].concat(collections)}
                                getOptionLabel={opt => opt.label || `${opt.Name} ${opt.Description && `- ${opt.Description}`}`}
                                getOptionValue={opt => opt.value || opt.WatchListID}
                                value={selectedWatchlists}
                                onChange={this.handleWatchlistChange}
                                isMulti
                                classNamePrefix='no-width-dropdown-input'
                                components={{ 'Option': CustomOption }}
                                updateNew={this.handleWatchlistChange}
                                toggleMenuIsOpen={this.toggleMenuIsOpen}
                                menuIsOpen={this.state.menuIsOpen}
                                onMenuOpen={e => { this.toggleMenuIsOpen(!this.state.menuIsOpen) }}
                                onBlur={e => { this.handleIsRelated(e) }}
                                onKeyDown={e => {
                                    // So, arrow keys let you navigate through the options. But we want to be able to auto tab into the new input.
                                    // This works for the most part, until you tab into the select initially. Then you need to focus on that specifically.
                                    if (e.key === 'Tab' && this.selectRef?.current?.select?.state?.focusedOption?.isNew) {
                                        e.preventDefault();
                                        document.getElementById('add-new')?.focus();
                                    } else if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                                        const current = this.selectRef?.current?.select?.state?.focusedOption?.WatchListID;
                                        const menuOptions = this.selectRef?.current?.select?.state?.menuOptions?.render;
                                        if (menuOptions && menuOptions.length > 1 && current) {
                                            const index = menuOptions.findIndex(o => o.data?.WatchListID === current);
                                            if (index === 1 && e.key === 'ArrowUp') {
                                                this.selectRef?.current?.select?.focusOption('up');
                                                setTimeout(() => document.getElementById('add-new')?.focus())
                                            } else if (index === menuOptions.length - 1 && e.key === 'ArrowDown') {
                                                this.selectRef?.current?.select?.focusOption('down');
                                                setTimeout(() => document.getElementById('add-new')?.focus())
                                            }
                                        } else if (menuOptions && this.selectRef?.current?.select?.state?.focusedOption === undefined && e.key === 'ArrowDown') {
                                            setTimeout(() => document.getElementById('add-new')?.focus())
                                        }
                                    }
                                }}
                                manuallyFocusTheNextOne={this.manuallyFocusTheNextOne}
                                handleIsRelated={this.handleIsRelated}
                            />
                        </div>
                        <div className="inline-list">
                            <br />
                            {this.props.collectionIsSaving ?
                                <div><span className="small-spinner"></span></div>
                                :
                                <React.Fragment>
                                    <button disabled={buttonDisabled} style={{ marginLeft: "0px" }} className="button" type="button" onClick={() => this.addToWatchlists(undefined)}>Add</button>
                                </React.Fragment>
                            }
                        </div>
                    </div>
                    {messages}
                </div>
            );
        }
        return (
            <>
                {this.state.showPopup[DELETE] &&
                    <DeleteWatchlistModal close={() => this.togglePopup(DELETE)} disabled={this.props.collectionIsSaving} delete={this.deleteCollection} singular={true} />
                }
                {this.state.showPopup[MERGE] &&
                    <div className='popup' onClick={() => this.togglePopup(MERGE)}>
                        <div className='popup-inner merge' onClick={e => e.stopPropagation()}>
                            <div className='header'>
                                <div className='title'>Import Watchlist</div>
                                <button onClick={() => this.togglePopup(MERGE)} className="close-cross" aria-label="close modal" />
                            </div>
                            <p id='add-watchlist-label'>Select the watchlist(s) you want to import this watchlist into.</p>
                            <div className="inner-grid">
                                <div>
                                    <Select
                                        ref={this.selectRef}
                                        isDisabled={this.props.collectionIsSaving}
                                        id="sr-watchlist-name-control-bad"
                                        styles={selectStyle}
                                        options={[{ isNew: true }].concat(collections.filter(c => c.WatchListID !== selectedCollection.WatchListID))}
                                        getOptionLabel={opt => opt.label || `${opt.Name}`}
                                        getOptionValue={opt => opt.value || opt.WatchListID}
                                        value={selectedMergeWatchlists}
                                        onChange={this.handleMergeWatchlistChange}
                                        isMulti
                                        classNamePrefix='no-width-dropdown-input'
                                        components={{ 'Option': CustomOption }}
                                        updateNew={this.handleMergeWatchlistChange}
                                        toggleMenuIsOpen={this.toggleMenuIsOpen}
                                        menuIsOpen={this.state.menuIsOpen}
                                        onMenuOpen={e => { this.toggleMenuIsOpen(!this.state.menuIsOpen) }}
                                        onBlur={e => { this.handleIsRelated(e) }}
                                        onKeyDown={e => {
                                            // So, arrow keys let you navigate through the options. But we want to be able to auto tab into the new input.
                                            // This works for the most part, until you tab into the select initially. Then you need to focus on that specifically.
                                            if (e.key === 'Tab' && this.selectRef?.current?.select?.state?.focusedOption?.isNew) {
                                                e.preventDefault();
                                                document.getElementById('add-new')?.focus();
                                            } else if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                                                const current = this.selectRef?.current?.select?.state?.focusedOption?.WatchListID;
                                                const menuOptions = this.selectRef?.current?.select?.state?.menuOptions?.render;
                                                if (menuOptions && menuOptions.length > 1 && current) {
                                                    const index = menuOptions.findIndex(o => o.data?.WatchListID === current);
                                                    if (index === 1 && e.key === 'ArrowUp') {
                                                        this.selectRef?.current?.select?.focusOption('up');
                                                        setTimeout(() => document.getElementById('add-new')?.focus())
                                                    } else if (index === menuOptions.length - 1 && e.key === 'ArrowDown') {
                                                        this.selectRef?.current?.select?.focusOption('down');
                                                        setTimeout(() => document.getElementById('add-new')?.focus())
                                                    }
                                                } else if (menuOptions && this.selectRef?.current?.select?.state?.focusedOption === undefined && e.key === 'ArrowDown') {
                                                    setTimeout(() => document.getElementById('add-new')?.focus())
                                                }
                                            }
                                        }}
                                        manuallyFocusTheNextOne={this.manuallyFocusTheNextOne}
                                        handleIsRelated={this.handleIsRelated}
                                    />
                                </div>
                                <div className="inline-list">
                                    {this.props.collectionIsSaving ?
                                        <div><span className="small-spinner"></span></div>
                                        :
                                        <React.Fragment>
                                            <button disabled={mergeButtonDisabled} style={{ marginLeft: "0px" }} className="button" type="button" onClick={() => this.addToWatchlists(true)}>Import</button>
                                            <button className="button secondary" onClick={() => this.togglePopup(MERGE)}>Cancel</button>
                                        </React.Fragment>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.showPopup[COPY] &&
                    <CopyWatchlistsPopup closePopup={() => this.togglePopup(COPY)} currentWatchlist={this.props.selectedCollection} copyWatchlist={this.copyWatchlist} watchlistNames={this.props.collections.map(s => s.Name)} />
                }
                <div className="collection-controls inner-grid watchlist-selected">
                    {this.state.editWatchlistName ?
                        <div className="dlas-forms flex-row flex-start inline-list edit-watchlist-name">
                            <div className="label-above-input">
                                <label htmlFor="sr-selected-watchlist-name" className="label">Name {!this.state.newName && <span className="fail">required</span>}</label>
                                <input
                                    id="sr-selected-watchlist-name"
                                    value={this.state.newName}
                                    placeholder="Name"
                                    onChange={e => this.handleTextChange('newName', e.target.value)}
                                />
                            </div>
                            <div className="label-above-input">
                                <label htmlFor="sr-selected-watchlist-desc" className="label">Description</label>
                                <input
                                    id="sr-selected-watchlist-desc"
                                    value={this.state.newDescription}
                                    placeholder="Description"
                                    onChange={e => this.handleTextChange('newDescription', e.target.value)}
                                />
                            </div>
                            {this.props.collectionIsSaving ?
                                <div className="small-spinner"></div>
                                :
                                <div className="inline-list save-or-delete">
                                    <button aria-label="save" onClick={this.saveWatchlistName} disabled={!this.state.newName} type="button" className="icon save"></button>
                                    <button aria-label="cancel" onClick={this.toggleEditWatchlistName} type="button" className="icon delete"></button>
                                </div>
                            }
                        </div>
                        :
                        <div className="watchlist-info">
                            <div className="inline-list">
                                <span className="name">{selectedCollection ? selectedCollection.Name : calendarHeader ? calendarHeader.Name : ''}</span>
                                <div role="button" aria-label="edit watchlist name and description" className="icon edit" onClick={() => !this.props.collectionIsSaving && this.toggleEditWatchlistName()}></div>
                            </div>
                            <span className="description">{selectedCollection ? selectedCollection.Description : calendarHeader ? calendarHeader.Description : ''}</span>
                        </div>
                    }
                    <div className="close-or-delete-watchlist align-right inline-list" style={this.state.editWatchlistName ? { display: 'none' } : {}}>
                        <button type="button" disabled={searchMade || this.props.isFetching || this.props.collectionIsSaving} onClick={() => this.togglePopup(DELETE)} className="button danger">Delete Watchlist</button>
                        {searchMade && !calendarHeader ?
                            <button type="button" disabled={this.props.collectionIsSaving} onClick={() => this.props.selectCollection(selectedCollectionIndex, true)} className="button secondary">Back to watchlist</button>
                            :
                            <button type="button" disabled={this.props.collectionIsSaving} onClick={() => this.props.selectCollection(-1)} className="button secondary">Close</button>
                        }
                    </div>
                </div>
                <WatchlistNotifications
                    selectedCollection={this.props.selectedCollection}
                    handleCollectionChange={this.props.handleCollectionChange}
                    memberList={this.props.memberList}
                    committeeList={this.props.committeeList}
                    criteriaTypes={this.props.criteriaTypes}
                    collectionIsSaving={this.props.collectionIsSaving}
                />
                <div className={'action-holder ' + (this.props.billList.length === 0 ? 'empty-watchlist' : '')}>
                    {!searchMade && this.props.billList.length > 0 ? <>
                        <button aria-label="remove watchlist bills" onClick={this.props.removeWatchlistBills} type="button" disabled={this.props.checkedBills.every(b => b === false) || this.props.collectionIsSaving} className="button danger remove-bills">Remove Bill(s)</button>
                        <button aria-label="toggle all notes" disabled={this.props.collectionIsSaving} className="button toggle-all-notes" onClick={this.props.toggleAllNotes} type="button">{this.props.showAllNotes ? "Hide" : "Show"} Notes +/-</button>
                        <button type='button' disabled={this.props.collectionIsSaving} onClick={() => this.handleToggleCompositeView()} className='button primary to-composite-view'>Composite View</button>
                        <button onClick={() => this.props.toggleReportMaker()} id="create-report-button" type="button" className={`${this.props.selectedCollection ? 'set-right ' : ''}button create-report`} style={{ marginRight: '0px' }}>Create Report</button>
                        {isPaid ? <>
                            <button type="button" disabled={this.props.collectionIsSaving} onClick={() => this.togglePopup(COPY)} className="button primary copy-watchlist">Copy</button>
                            <button type="button" disabled={this.props.collectionIsSaving} onClick={() => this.togglePopup(MERGE)} className="button primary merge-watchlist">Import</button>
                        </>
                            : <><div /><div /></>
                        } </>
                        : <><div /><div /><div /><div /><div /><div /></>
                    }
                    {!searchMade && <QuickAdd
                        quickAddBills={this.props.quickAddBills}
                        quickAddErr={this.props.quickAddErr}
                        collectionIsSaving={this.props.collectionIsSaving || this.props.isFetching}
                    />
                    }
                    {messages}
                </div >
            </>
        )
    }
}

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px'
    }),
}

export default CollectionControls;

// This way we can just clear the state without much effort
const CopyWatchlistsPopup = props => {

    const [newName, setNewName] = React.useState('Copy of ' + props.currentWatchlist.Name);

    const isDuplicate = props.watchlistNames.includes(newName);

    return <div className='popup' onClick={() => props.closePopup()}>
        <div className='popup-inner merge' onClick={e => e.stopPropagation()}>
            <div className='header'>
                <div className='title'>Copy Watchlist</div>
                <button onClick={() => props.closePopup()} className="close-cross" aria-label="close modal" />
            </div>
            <p>Enter the new watchlist's name.</p>
            <div className="inner-grid">
                <div className='dlas-forms'>
                    <input type="text" className='copy' value={newName} onChange={e => setNewName(e.target.value)} style={{ width: '100%' }} />
                </div>
                <div className="inline-list">
                    <button disabled={!newName || isDuplicate} className="button" type="button" onClick={() => props.copyWatchlist(newName)} >Copy</button>
                    <button className="button secondary" onClick={() => props.closePopup()}>Cancel</button>
                </div>
                {isDuplicate && <DuplicateWatchlistWarning styleAdjustments={{ marginTop: '10px' }} />}
            </div>
        </div>
    </div>
}

const MessageBox = props => {

    const [show, toggleShow] = React.useState(props.show !== undefined ? false : undefined);

    return <div className={"message-box " + props.type ?? ''}>
        <button className='close' onClick={() => props.closeMessage()} aria-label='close message' />
        {show ? props.text : (props.show ?? props.text)}
        {props.show !== undefined &&
            (show ? <button className='icon arrow-up' aria-label='hide add bills message' onClick={() => toggleShow(s => !s)} />
                :
                <button className='icon arrow-down' aria-label='show add bills message' onClick={() => toggleShow(s => !s)} />
            )}
    </div>
}
